import { getButtonActionByActionType, trackLink } from '@vfit/shared/data-access';
import { RedCard } from './components/redCard';
import { IRedHubCardProps } from './redHubCard.models';
import { useDeviceType } from '@vfit/shared/hooks';
import { createPortal } from 'react-dom';
import { useRouter } from 'next/router';
import { useQueryClient } from 'react-query';

const RedHubCard = ({ render, redHubCardConfig, width }: IRedHubCardProps) => {
  // const [_, forceRender] = useState(0);
  //  console.log('render', render);
  const { isMobile, isTablet } = useDeviceType();
  const { push } = useRouter();
  const queryClient = useQueryClient();

  const handleButtonClick = () => {
    trackLink(redHubCardConfig?.actionMode?.title || '');
    getButtonActionByActionType(redHubCardConfig.actionMode, push, queryClient);
  };

  // useEffect(() => {
  //   // Forza un rerender sia al primo mount che quando cambia "render"
  //   forceRender((prev) => prev + 1);
  // }, [render]);

  const renderRedCard = () => {
    let elementToAppendTo;

    if (isMobile || isTablet) {
      if (redHubCardConfig.mobileTabletView === 'true') {
        elementToAppendTo = document.getElementById(`${redHubCardConfig.idForPortal}_container`);
      }
    } else {
      elementToAppendTo = document.getElementById(redHubCardConfig.idForPortal);
    }
    if (!elementToAppendTo) return null;

    return createPortal(
      <div id={render}>
        <RedCard data={redHubCardConfig} width={width} onClick={handleButtonClick} id={render} />
      </div>,
      elementToAppendTo
    );
  };

  return renderRedCard();
};

export default RedHubCard;

